/* eslint-env browser */
import * as React from 'react'

import withTranslator from '../TranslatorProvider'

const PropTypes = require('prop-types')
const axios = require('axios')
const classNames = require('classnames')

const OneCatch = require('./CatchItem')

class Catches extends React.Component {
  constructor(props) {
    super(props)
    const { catches } = this.props
    this.state = {
      catches: catches || [],
      catchesFetched: true,
      loadingMore: false,
      hasMore: true,
    }
    this.getCatches = this.getCatches.bind(this)
    this.showMore = this.showMore.bind(this)
    this.getLoadMorePromise = this.getLoadMorePromise.bind(this)
    this.onItemClick = this.onItemClick.bind(this)
  }

  componentDidMount() {
    const { catches } = this.state
    if (!catches || catches.length === 0) {
      this.showMore()
    }
  }

  onItemClick(e, id) {
    // modal not active on mobile
    if (window && window.matchMedia('(max-width: 770px)').matches) {
      return false
    }
    const { showArrayModal } = this.props
    if (!showArrayModal) {
      return false
    }
    e.preventDefault()
    const { catches } = this.state
    const initialIndex = catches.findIndex(elt => elt.id === id) || 0
    showArrayModal({
      isActive: true,
      initialIndex,
      ids: catches.map(elt => elt.id),
      type: 'fishCatches',
    })
    return true
  }

  getCatches() {
    const { loadingMore, catches } = this.state
    const { loadMore } = this.props

    if (loadingMore) {
      return
    }
    this.setState({ loadingMore: true })
    const limit = loadMore && loadMore.type === 'createdBy' ? 48 : 24
    this.getLoadMorePromise({ limit })
      .then(res => {
        const actualCatches = catches || []
        const allCatches = actualCatches.concat(res.data)
        this.setState({
          catches: allCatches,
          catchesFetched: true,
          loadingMore: false,
          hasMore: res.data.length >= limit,
        })
      })
      .catch(() => {})
  }

  getLoadMorePromise({ limit }) {
    const { catches } = this.state
    const { loadMore } = this.props
    if (!loadMore) {
      return Promise.reject()
    }
    if (loadMore.type === 'contest') {
      return axios.get(`/api/contests/${loadMore.contestId}/catches`, {
        params: {
          limit,
          offset: catches.length,
          withFishes: true,
          withCurrentUserLikes: true,
        },
      })
    }
    if (loadMore.type === 'species') {
      let before
      if (catches.length > 0) {
        before = new Date(catches[catches.length - 1].date).getTime()
      }
      return axios.get(`/api/fishes/${loadMore.speciesId}/lightFishCatches`, {
        params: {
          limit,
          withFish: true,
          withCreator: true,
          before,
        },
      })
    }
    if (loadMore.type === 'createdBy') {
      return axios.get(`/api/users/${loadMore.userId}/lightFishCatches`, {
        params: {
          limit,
          withFish: true,
          withCreator: true,
          offset: catches.length,
        },
      })
    }
    return Promise.reject()
  }

  showMore() {
    this.getCatches()
  }

  render() {
    const {
      translate,
      locale,
      userSettings,
      isLoggedIn,
      displayLikes,
      loadMore,
      texts,
      simpleGrid,
      customItemClassName,
      isSingleLine,
      containerStyle,
      nonLoadableCatches,
    } = this.props
    const { catches, catchesFetched, loadingMore, hasMore } = this.state

    const zeCatches = nonLoadableCatches || catches

    const canLoadMore = !!loadMore && hasMore

    const endOfFeedText = texts.endOfFeed || translate('catchGrid.endOfFeed')
    const loadMoreText = texts.loadMore || translate('catchGrid.loadMore')

    return (
      <div
        className={classNames(
          'columns is-mobile is-variable is-1',
          { 'is-multiline is-centered': !isSingleLine },
          { 'is-gapless': !!simpleGrid }
        )}
        style={containerStyle}
      >
        {zeCatches.map(elt => (
          <div
            className={classNames('column', customItemClassName || 'is-6-mobile is-4-tablet is-3-desktop')}
            key={elt.id}
          >
            <OneCatch
              fishCatch={elt}
              actor={elt.creator}
              locale={locale}
              userSettings={userSettings}
              isLoggedIn={isLoggedIn}
              displayLikes={displayLikes}
              simpleGrid={simpleGrid}
              onClick={this.onItemClick}
            />
          </div>
        ))}
        {!simpleGrid && !nonLoadableCatches && (
          <div
            className="column is-12 has-text-centered"
            style={{ paddingTop: 20, paddingBottom: 20, textAlign: 'center' }}
          >
            {catchesFetched && !loadingMore && canLoadMore && (
              <button onClick={this.showMore} type="button" className="button is-call-to-action">
                {loadMoreText}
              </button>
            )}
            {catchesFetched && loadingMore && (
              <button className="button is-call-to-action is-loading" type="button">
                {loadMoreText}
              </button>
            )}
            {!canLoadMore && !!loadMore && zeCatches.length > 0 && endOfFeedText}
          </div>
        )}
      </div>
    )
  }
}

Catches.propTypes = {
  catches: PropTypes.array,
  nonLoadableCatches: PropTypes.array,
  texts: PropTypes.object,
  displayLikes: PropTypes.bool,
  loadMore: PropTypes.object,
  simpleGrid: PropTypes.bool,
  isSingleLine: PropTypes.bool,
  customItemClassName: PropTypes.string,
  userSettings: PropTypes.object,
  locale: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool,
  showArrayModal: PropTypes.func,
  containerStyle: PropTypes.object,
}

Catches.defaultProps = {
  catches: [],
  nonLoadableCatches: null,
  texts: {},
  displayLikes: true,
  loadMore: null,
  simpleGrid: false,
  isSingleLine: false,
  customItemClassName: null,
  userSettings: {},
  isLoggedIn: false,
  showArrayModal: null,
  containerStyle: {},
}

module.exports = withTranslator(Catches)
